import InputField from "../../components/forms/input-field";
import ToggleSwitch from "../../components/forms/toggle-switch";
import TextAreaField from "../../components/forms/textarea-field";
import { Field, useFormikContext, FieldArray } from "formik";
import { Info } from "lucide-react";
const FlowDetails = () => {
    const { values, setFieldValue } = useFormikContext();
    return (
        <div className="w-full">
                    <div className="flex items-start gap-4 flex-wrap">
                    <div className="w-full md:w-1/2">
                        <InputField
                        type="text"
                        name="flow_name"
                        placeholder="Enter Flow Name"
                        label="Name"
                        isRequired={true}
                        labelWidth="7rem"
                        />
                    </div>
                    <div className="flex items-center mt-[10px]">
                        <label
                        htmlFor="is_active"
                        className="text-[length:var(--input-label-font-size)] text-[var(--input-label-color)] font-[var(--input-label-font-weight)] flex items-center gap-2"
                        >
                        Active
                        </label>
                        <div className="ml-2 mt-[2px] flex flex-row items-center">
                            <ToggleSwitch
                                checked={values.is_active}
                                onClick={() =>
                                setFieldValue("is_active", !values.is_active)
                                }
                            />
                            <Info size={15} fill="var(--description-color)" stroke="#fff"/>
                        </div>
                    </div>
                    </div>
                    <div className="mt-4">
                    <TextAreaField
                        label="Description"
                        placeholder="Enter Description"
                        name="description"
                        id="description"
                        labelWidth="7rem"
                        maxLength={255}
                    />
                    </div>
                </div>
    );
}

export default FlowDetails;